export default __webpack_public_path__ + "static/media/Blade of the Ancient Sands.370c018f.jpg";